export default {
  CLOSE: 'Schließen',
  BTN: {
    DOWNLOAD: 'Tauschmeldung runterladen',
  },
};
